import { ui } from "@patient-watch/ui";
import { Button } from "@patient-watch/ui/button";
import { useAuth } from "@/utils/auth";
import { Menu } from "lucide-react";

import { useLogoutMutation } from "../../auth/api/useLogoutMutation";
import MobileNavigationApp from "../app/MobileNavigation";
import { useProfileCopy } from "@/features/i18n/profileCopy";

export function Burger() {
    const auth = useAuth();
    const logout = useLogoutMutation();
    const copy = useProfileCopy();

    return (
        <ui.Sheet>
            <ui.SheetTrigger asChild>
                <Button className="px-4 w-fit text-md" variant="outline">
                    <Menu size={20} />
                    {copy.menu}
                </Button>
            </ui.SheetTrigger>
            <ui.SheetContent>
                <MobileNavigationApp />

                <ui.SheetFooter className="gap-4 md:gap-2 mt-8">
                    {auth.isAuthenticated && (
                        <ui.SheetClose>
                            <Button onClick={() => logout.mutate()} variant="outline" className="w-full">
                                {copy.logout}
                            </Button>
                        </ui.SheetClose>
                    )}
                    <ui.SheetClose>
                        <Button variant="outline" className="w-full">
                            {copy.close}
                        </Button>
                    </ui.SheetClose>
                </ui.SheetFooter>
            </ui.SheetContent>
        </ui.Sheet>
    );
}
